<div class="dasa-forgot">
  <div class="dasa-forgot__card">
    <div class="dasa-forgot__logo">
      <img [src]="imageUrl" alt="DASA TECH" />
    </div>
    <h2 class="dasa-forgot__title">Forgot your password?</h2>
    <p class="dasa-forgot__subtitle">
      Enter the email tied to your DASA TECH account and we&rsquo;ll send you a reset link.
    </p>

    <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()" class="dasa-forgot__form" novalidate>
      <div class="form-group">
        <label for="email" class="form-label">Email</label>
        <input type="email"
          placeholder="you@business.com"
          class="form-control"
          formControlName="email"
          id="email"
          autocomplete="email"
          [ngClass]="{ 'is-invalid': (submitted || f.email.dirty || f.email.touched) && f.email.errors }">
        <div *ngIf="(submitted || f.email.dirty || f.email.touched) && f.email.errors" class="invalid-feedback">
          <div *ngIf="f.email.errors.required">Email is required</div>
        </div>
      </div>

      <button type="submit" class="btn btn-accent dasa-forgot__submit">Send reset link</button>

      <div class="dasa-forgot__back">
        Remembered it? <a routerLink="/login" class="dasa-forgot__link">Return to sign in</a>
      </div>
    </form>
  </div>
</div>
